import { Asset } from "@iventis/types/asset";
import { BasemapDataStore } from "./basemap-data-store";

export type Sitemap3d = Asset;

export class Sitemap3dDataStore extends BasemapDataStore<Sitemap3d> {
    protected async getBasemapApiCall(sitemapId: string): Promise<Sitemap3d> {
        const sitemapAsset = await this.getBasemapAsset(sitemapId);
        return { ...sitemapAsset, url: `${sitemapAsset.url}?${sitemapAsset.signature}&assetVersion=${sitemapAsset.updatedAt.toISOString()}` };
    }
}
